import React from 'react';
import _get from 'lodash/get';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import CheckBoxGroup from '@lib/components/CheckBoxGroup/CheckBoxGroup';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import { ComponentProps, defaultProps } from '../types';

export default function DecisionBoxPreview(props: ComponentProps) {
  const { t } = props;
  const text = _get(
    props,
    `${FormTemplateFieldNames.Options}.0.${FormTemplateFieldNames.Values}.0`,
    '',
  );
  const options = _get(props, FormTemplateFieldNames.Options, []);
  const preparedOptions = options.map(({ values }) => ({
    value: values[0],
    label: text || t('decision-box-message'),
  }));
  return (
    <CheckBoxGroup
      options={preparedOptions}
      value={undefined}
      name={FormTemplateQuestionFieldsKindEnum.DecisionBox}
      {...defaultProps}
    />
  );
}
